import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { createUseStyles } from '@glu/theming';
import PtxAsh from 'system/components/logos/PtxAsh';
import util from 'system/util';

const useStyles = createUseStyles(({
  breakpoints,
  typography,
  colors: {
    white
  }
}) => ({
  brandLogo: {
    border: 0,
    boxSizing: 'border-box',
    height: '100%',
    padding: '7px 10px',
    display: 'flex',
    alignItems: 'center'
  },
  navigation: {
    background: 'linear-gradient(90deg, #1fa2ff, #004d99)',
    height: 50,
    display: 'flex',
    maxWidth: ({ isGluAsh }) => (isGluAsh ? 'auto' : 1820),
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 1
  },
  navigationListLeft: {
    listStyleType: 'none',
    display: 'flex',
    margin: 0,
    width: 'auto'
  },
  navigationListRight: {
    listStyleType: 'none',
    display: 'flex',
    margin: [0, 60, 0, 'auto']
  },
  link: {
    fontFamily: typography.fontFamily,
    borderBottom: '5px solid transparent',
    color: white,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '20px',
    padding: '30px 10px 10px',
    position: 'relative',
    textDecoration: 'none!important',
    whiteSpace: 'nowrap',

    '&:hover, &:focus': {
      // backgroundColor: ({ disabled }) => (!disabled ? 'transparent !important' : undefined),
      // borderColor: ({ disabled }) => (!disabled ? [palette.primary.info, '!important'] : undefined),
      color: ({ disabled }) => (!disabled && white),
      // color: ({ disabled }) => (!disabled ? [palette.primary.white, '!important'] : undefined),
      outline: '1px solid transparent'
    },

    [`@media screen and (min-width: ${breakpoints.values.lg}px)`]: {
      padding: '30px 10px 10px'
    }
  },
}));

const DummyNavigation = ({ children, homeUrl }) => {
  const classes = useStyles({ isGluAsh: util.isGluAsh() });
  const history = useHistory();

  return (
    <nav className={classes.navigation}>
      <ul className={children ? classes.navigationListRight : classes.navigationListLeft}>
        {children && React.Children.map(children, child => (
          <li>
            {child}
          </li>
        ))}
        <li>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            href="#"
            className={classNames(classes.link, classes.brandLogo)}
            onClick={(e) => {
              e.preventDefault();
              const url = homeUrl || `${window.location.protocol}//${window.location.hostname}`;
              if (url.indexOf('://') > 0) {
                window.location.href = url;
              } else {
                history.push(url);
              }
            }}
          >
            <PtxAsh />
          </a>
        </li>
      </ul>
    </nav>
  );
};

DummyNavigation.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
    PropTypes.node,
    PropTypes.string
  ]),
  homeUrl: PropTypes.string
};

DummyNavigation.defaultProps = {
  children: null,
  homeUrl: null
};

export default DummyNavigation;